import { render, staticRenderFns } from "./PieChartAnswerItem.vue?vue&type=template&id=c5efa85c&"
import script from "./PieChartAnswerItem.vue?vue&type=script&lang=js&"
export * from "./PieChartAnswerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports